__turbopack_context__.v({
  "contactCardHeaderBlueTitle": "ContactCard-module-scss-module__Ca7jNa__contactCardHeaderBlueTitle",
  "contactCardHeaderHeader": "ContactCard-module-scss-module__Ca7jNa__contactCardHeaderHeader",
});
